import React from 'react';
import { 
  ShoppingCart, 
  Shield, 
  Home, 
  Anchor, 
  Wrench, 
  Cable, 
  FlaskConical, 
  Plug 
} from 'lucide-react';

const offerings = [
  {
    id: 1,
    title: 'Provision Stores',
    description: 'Essential daily goods and supplies for maritime needs.',
    icon: <ShoppingCart size={40} />,
  },
  {
    id: 2,
    title: 'Safety Stores',
    description: 'High-quality safety gear and protective equipment for maritime safety.',
    icon: <Shield size={40} />,
  },
  {
    id: 3,
    title: 'Cabin Stores',
    description: 'Essential supplies and equipment for cabin comfort and functionality.',
    icon: <Home size={40} />,
  },
  {
    id: 4,
    title: 'Deck Stores',
    description: 'Durable deck equipment and accessories for ship operations.',
    icon: <Anchor size={40} />,
  },
  {
    id: 5,
    title: 'Hardware & Tools',
    description: 'Quality hardware and essential tools for various industries.',
    icon: <Wrench size={40} />,
  },
  {
    id: 6,
    title: 'Ropes & Lifting Tackles',
    description: 'Durable ropes and lifting equipment for maritime operations.',
    icon: <Cable size={40} />,
  },
  {
    id: 7,
    title: 'Marine Chemicals',
    description: 'Specialized chemicals designed for marine applications.',
    icon: <FlaskConical size={40} />,
  },
  {
    id: 8,
    title: 'Electrical Stores',
    description: 'Electrical components and wiring solutions for maritime and industrial sectors.',
    icon: <Plug size={40} />,
  },
];

const Offerings = () => {
  return (
    <section className="section-y bg-lightGray">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-14 md:mb-16">
          <p className="section-kicker">Capabilities</p>
          <h2 className="section-title">Our Offerings</h2>
          <p className="section-subtitle">
            Comprehensive maritime solutions tailored to meet your vessel's every need
          </p>
        </div>

        {/* Offerings Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {offerings.map((offering) => (
            <div
              key={offering.id}
              className="card-surface p-6 lg:p-7 flex flex-col min-h-[12rem] group"
            >
              {/* Icon */}
              <div className="text-teal mb-4 group-hover:scale-110 transition-transform duration-300">
                {offering.icon}
              </div>
              
              {/* Title */}
              <h3 className="text-xl font-bold text-navy mb-3">
                {offering.title}
              </h3>
              
              {/* Description */}
              <p className="text-darkGray/70 text-sm leading-relaxed">
                {offering.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Offerings;